import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { LeadSection } from '../components/LeadSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VisionSection } from '../components/VisionSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { OfferSection } from '../components/OfferSection';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
import { FooterSection } from '../components/FooterSection';
import { UrgencyBanner } from '../components/UrgencyBanner';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden pb-20 md:pb-0" data-id="element-378">
      <UrgencyBanner data-id="element-379" />
      <HeroSection data-id="element-380" />
      <LeadSection data-id="element-381" />
      <ProblemSection data-id="element-382" />
      <ForWhoSection data-id="element-383" />
      <SolutionSection data-id="element-384" />
      <TestimonialsSection data-id="element-385" />
      <VisionSection data-id="element-386" />
      <FAQSection data-id="element-387" />
      <GuaranteeSection data-id="element-388" />
      <OfferSection data-id="element-389" />
      <FooterSection data-id="element-390" />
      <StickyMobileCTA data-id="element-391" />
    </main>;
}